import Login
  from './views/Login'

import Orders
  from './views/Orders'

// ------------------

import OrderSteps
  from './views/Order/Steps'

import OrderDescriptions
  from './views/Order/Descriptions'

import OrderWorkPictures
  from './views/Order/Steps/WorkPictures'

import OrderWorkSignature
  from './views/Order/Steps/WorkSignature'

import OrderLineQr
  from './views/Order/Steps/LineQr.vue'

import OrderCampaignInfo
  from './views/Order/Steps/CampaignInfo'

import OrderSurvey
  from './views/Order/Steps/Survey'

import OrderPayment
  from './views/Order/Steps/Payment'

import OrderReceipt
  from './views/Order/Steps/Receipt'

import OrderReview
  from "@/views/Order/Steps/OrderReview";

import OrderPurchase
  from './views/Order/Steps/Purchase'

import OrderQuotes
  from './views/Order/Steps/Quotes'

import OrderQuoteSteps
  from './views/Order/QuoteSteps'

import OrderQuoteResources
  from './views/Order/QuoteSteps/Resources'

import OrderQuoteResourceCreate
  from './views/Order/QuoteSteps/ResourceCreate'

import OrderQuoteInfoInput
  from './views/Order/QuoteSteps/InfoInput'

// -------------------------
export default [
  {
    path: '*',
    redirect: '/orders'
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
  },
  {
    alias: '/',
    path: '/orders',
    name: 'orders',
    component: Orders
  },
  {
    path: '/orders/:id',
    name: 'orderDesc',
    component: OrderDescriptions
  },
  {
    path: '/orders/:id/steps',
    name: 'orderSteps',
    component: OrderSteps,
    children: [
      {
        path: 'beforeworkpictures',
        name: 'beforeworkpictures',
        component: OrderWorkPictures,
        props: {step: 'before'}
      },
      {
        path: 'afterworkpictures',
        name: 'afterworkpictures',
        component: OrderWorkPictures,
        props: {step: 'after'}
      },
      {
        path: 'beforeworksignature',
        name: 'beforeworksignature',
        component: OrderWorkSignature,
        props: {step: 'before'}
      },
      {
        path: 'afterworksignature',
        name: 'afterworksignature',
        component: OrderWorkSignature,
        props: {step: 'after'}
      },
      {
        path: 'orderlineqr',
        name: 'orderlineqr',
        component: OrderLineQr,
        props: {step: 'before'}
      },
      {
        path: 'paymentlineqr',
        name: 'paymentlineqr',
        component: OrderLineQr,
        props: {step: 'payment'}
      },
      {
        path: 'survey',
        name: 'survey',
        component: OrderSurvey
      },
      {
        path: 'campaigninfo',
        name: 'campaigninfo',
        component: OrderCampaignInfo
      },
      {
        path: 'payment',
        name: 'payment',
        component: OrderPayment
      },
      {
        path: 'receipt',
        name: 'receipt',
        component: OrderReceipt
      },
      {
        path: 'order_review',
        name: 'orderReview',
        component: OrderReview,
        props: {step: ''}
      },
      {
        path: 'order_review',
        name: 'paymentOrderReview',
        component: OrderReview,
        props: {step: 'payment'}
      },
      {
        path: 'purchase',
        name: 'purchase',
        component: OrderPurchase
      },
      {
        path: 'quotes',
        name: 'quotes',
        component: OrderQuotes
      }
    ]
  },
  {
    path: '/orders/:id/quote_steps',
    name: 'orderQuoteSteps',
    component: OrderQuoteSteps,
  },
  {
    path: '/orders/:id/quote_steps/resources',
    name: 'orderQuoteResources',
    component: OrderQuoteResources,
  },
  {
    path: '/orders/:id/quote_steps/resources/create',
    name: 'orderQuoteResourceCreate',
    component: OrderQuoteResourceCreate,
  },
  {
    path: '/orders/:id/quote_steps/info_input',
    name: 'orderQuoteInfoInput',
    component: OrderQuoteInfoInput,
  },
]